module.exports = __webpack_public_path__ + "static/media/01anjianyuan.c48021cd.png";